// Generated by packages/fluxer-theme/sync.py. Do not edit.

export const DEFAULT_AVATAR_PRIMARY_COLORS = [0x252321, 0x35312d, 0x43382e, 0x2c3833, 0x3d3c36, 0x51483e] as const;
export const DEFAULT_PROFILE_ACCENT_COLOR = 0x252321;
export const DEFAULT_PROFILE_ACCENT_HEX = "#252321";
